import { IAirwebTicketLegacyUserInfo } from '@airweb/ticket-legacy-client';
import { ProductItem } from '~/types/product';

export const useDuplicate = defineStore('duplicate', {
  state: () => ({
    profile: null as null | IAirwebTicketLegacyUserInfo,
    product: null as null | ProductItem,
  }),
});
